<template>
  <div class="flows">
    <div class="image" v-show="image">
      <img :src="image" />
    </div>
  </div>
</template>
<script>

export default {
  name: 'DashboardFlowsAndHeatmap',
  components: {},
  props: {
    id: {
      type: String
    },
    dashboardId: {
      type: String
    },
    items: {
      type: Object,
      default() {
        return {}
      }
    },
    configs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      image: null,
      imageLoading: false,
      fieldsData: {}
    }
  },
  mounted() {
    this.rerender()
  },
  methods: {
    rerender() {
      this.fieldsData = { ...this.items }
      this.getImage()
    },

    getImage() {
      const body = {
        dashboard_id: this.dashboardId,
        element_id: this.id.replace(this.temp, ''),
        pipeline_id: this.configs.parameters['Pipeline']
      }
      const searchParams = new URLSearchParams(body)
      this.imageLoading = true
      const urlImage = `${process.env.VUE_APP_API_ENDPOINT ||
        window.location.origin}/api/dashboard/flowmap?${searchParams}`
      return fetch(urlImage, {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.image = data
          this.imageLoading = false
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.imageLoading = false
          this.$forceUpdate()
        })
    }
  }
}
</script>

<style lang="scss">
.flows {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-top: 0;
  padding-bottom: 0;
  .filters {
    margin: 0;
    .parametrs-list {
      margin-right: 0.75rem;
      flex-grow: 5;
      .field {
        .field-body {
          flex-grow: 5;
        }
        .field-label {
          min-width: unset;
          padding-top: 0;
          width: 100%;
          flex-basis: content;
          .label {
            text-align: right;
            width: 100%;
            min-width: unset;
          }
        }
      }
    }
  }
  .apply {
    justify-content: right;
    display: flex;
  }
}
</style>
